import { ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import BgNsExpander from '@britishgasenergy/react-nucleus/dist/nuc-components/NsExpander';

import { NsIconProps } from 'components/common/ns-icon/NsIcon';
import { pushEvent } from 'state/analytics/analytics-slice';

type NsExpanderProps = {
  type?: 'standard' | 'skyline';
  HeadingTag?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  heading: string;
  children?: ReactNode | ReactNode[];
  icon?: NsIconProps['type'];
  color?: 'yellow';
  open?: boolean;
  onToggle?: (event: CustomEvent) => void;
  slot?: string;
  id?: string;
  testId?: string;
};

export const NsExpander = ({
  heading,
  HeadingTag = 'h3',
  type = 'standard',
  open,
  icon,
  color,
  onToggle,
  children,
  slot,
  id,
  testId
}: NsExpanderProps) => {
  const dispatch = useDispatch();
  const onAccordionToggle = (event: CustomEvent) => {
    const action = event.detail.isOpen ? 'open' : 'close';
    dispatch(
      pushEvent({
        category: 'accordion',
        actionName: action,
        label: heading
      })
    );
    onToggle?.(event);
  };

  return (
    <BgNsExpander
      type={type}
      icon={icon}
      color={color}
      onToggle={onAccordionToggle}
      open={open}
      slot={slot}
      id={id}
      data-testid={testId}
    >
      <HeadingTag slot="heading">{heading}</HeadingTag>
      {children}
    </BgNsExpander>
  );
};
